<template>
  <div class="global-price-comparison">
    <div class="title">
      <img :src="images.title" alt="" class=""/>
    </div>
    <div class="content-box">
      <div class="direction-button is-left"
           :class="[{'is-disabled': disabledLeft}]"
           @click="directionLeft"
      ><i class="el-icon-arrow-left"></i></div>
      <div class="list-wrap" ref="listWrap">
        <template v-if="loading">
          <span style="line-height: 50px;"><i class="el-icon-loading"/> &nbsp;加载中...</span>
        </template>
        <div class="list"  ref="list" :style="`transform: translateX(${translateX}px);`" v-else>
          <div
            ref="item"
            class="price-comparison-item"
            v-for="(item,index) in list"
            :key="index" :style="`background-image: url('${images.itemBg}')`"
            @click="clickItem(item,index)"
            :alt="item.name"
          >{{item.name}}</div>
        </div>
      </div>
      <div class="direction-button is-right"
           :class="[{'is-disabled': disabledRight}]"
           @click="directionRight"
      ><i class="el-icon-arrow-right"></i></div>
    </div>

  </div>
</template>

<script>
export default {
  name: "globalPriceComparison",
  props:{
    loading:Boolean,
    list:{
      type:Array,
      default:()=>[],
    },
    // 单个item固定宽度
    itemWidth: {
      type:Number,
      default:160,
    },
    // 两个item间的固定间距
    itemSpace: {
      type:Number,
      default:15,
    },
  },
  data(){
    const ossPath = this.ossPath;
    return {
      images:{
        title: ossPath + "/pages/home/price_comparison_title.png",
        itemBg: ossPath + "/pages/home/price_comparison_item2.png",
      },
      // 需要切换
      isDirection:false,
      // 需要切换右
      isDirectionRight:false,
      // 切换位移坐标
      translateX:0,
    }
  },
  computed:{
    // 禁用左按钮
    disabledLeft(){
      return !this.isDirection || this.translateX === 0;
    },
    // 禁用右按钮
    disabledRight(){
      return !this.isDirection || !this.isDirectionRight;
    }
  },
  watch:{
    list:{
      immediate:true,
      handler(newVal){
        console.log("watch list",newVal)
        if(newVal && newVal.length){
          this.initListDirection();
        }else{
          this.resetTranslate();
        }
      },
    }
  },
  methods:{
    resetTranslate(){
      this.isDirection = false;
      this.isDirectionRight = false;
      this.translateX = 0;
    },
    initListDirection(){
      // let $listWrap = this.$refs.listWrap;
      // let $list = this.$refs.list;
      // let $items = this.$refs.item;
      // console.log("$listWrap",$listWrap,$listWrap.offsetWidth,$listWrap.scrollWidth)
      // console.log("$list",$list,$list.offsetWidth,$list.scrollWidth)
      // console.log("$items",$items)
      // if($listWrap && $list){
      //   let wrapWidth = $listWrap.offsetWidth;
      //   let listWidth = $list.offsetWidth;
      //   if(listWidth > wrapWidth){
      //     this.isDirection = true;
      //     this.isDirectionLeft = false;
      //     this.isDirectionRight = true;
      //   }
      // }
      if (this.list.length > 5) {
        this.isDirection = true;
        this.isDirectionRight = true;
      }else{
        this.resetTranslate();
      }
    },
    directionLeft(){
      if(this.disabledLeft) return false;
      let $list = this.$refs.list;
      if ($list) {
        let distance = this.itemWidth + this.itemSpace;
        if(-this.translateX >= distance){
          this.translateX += distance;
        }else {
          this.translateX = 0;
        }
        this.isDirectionRight = true;
      }
    },
    directionRight(){
      if(this.disabledRight) return false;
      let $listWrap = this.$refs.listWrap;
      let $list = this.$refs.list;
      if ($listWrap && $list) {
        let wrapWidth = $listWrap.offsetWidth;
        let listWidth = $list.offsetWidth;
        console.log(`wrapWidth`,wrapWidth);
        console.log(`listWidth`,listWidth);
        if(listWidth && wrapWidth && listWidth > wrapWidth){
          let boxSurplus = listWidth - wrapWidth;
          let distance = this.translateX === 0 ? this.itemWidth : this.itemWidth + this.itemSpace;
          let nextX = this.translateX - distance;
          console.log(`boxSurplus`,boxSurplus);
          console.log(`distance`,distance);
          console.log("nextX",nextX);
          console.log(`${boxSurplus} >= ${-nextX}`,boxSurplus >= -nextX);
          console.log(`${boxSurplus} >= (${-nextX} - ${this.itemSpace})`,boxSurplus >= (-nextX - this.itemSpace));
          if(boxSurplus >= -nextX){
            this.translateX -= distance;
          }else if( boxSurplus >= (-nextX - this.itemSpace)){
            this.translateX -= distance;
            this.isDirectionRight = false;
          }else{
            this.isDirectionRight = false;
          }
        }
      }
    },
    clickItem(item,index){
      this.$emit("clickItem",item,index);
    },
  },
}
</script>

<style scoped lang="less">
@buttonWidth:36px;
.global-price-comparison{
  height: 100px;
  background-color: #ffeee4;
  border-radius: 30px;
  display: flex;
  align-items: center;
  padding-left: 30px;
  box-sizing: border-box;
  .title{
    width: 160px;
    img{
      width: 100%;
      display: block;
      border: none;
      margin: 0 auto;
    }
  }
  .content-box{
    flex: 1;
    //padding-left: @buttonWidth + 20px;
    //padding-right: @buttonWidth + 20px;
    padding-left: 60px;
    padding-right: 60px;
    height: auto;
    min-height: 40px;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
  }
  .direction-button{
    position: absolute;
    z-index: 1;
    top: 50%;
    transform: translateY(-(@buttonWidth/2));
    display: flex;
    align-items: center;
    justify-content: center;
    width: @buttonWidth;
    height: @buttonWidth;
    box-sizing: border-box;
    //line-height: @buttonWidth;
    //text-align: center;
    border-radius: 50%;
    border: 1px solid #eddcd2;
    font-size: 24px;
    //font-weight: bold;
    color: #433228;
    i{
      font-weight: inherit;
    }
    &.is-left{
      left: 10px;
    }
    &.is-right{
      right: 10px;
    }
    &.is-disabled{
      background-color: #eddcd2;
      color: #999;
      cursor: not-allowed;
      opacity: 0;
    }
    &:not(.is-disabled){
      cursor: pointer;
      &:hover{
        border-color: #FF4D01;
        color: #FF4D01;
      }
      &:active{
        background-color: #ffe3e6;
      }
    }
  }
  .list-wrap{
    overflow: hidden;
    white-space: nowrap;
  }
  .list{
    transition: transform 0.3s ease;
    display: inline-flex;
    flex-wrap: nowrap;
  }
}
.price-comparison-item{
  display: inline-block;
  width: 160px;
  min-width: 160px;
  height: 50px;
  line-height: 50px;
  padding-right: 40px;
  padding-left: 10px;
  font-size: 18px;
  box-sizing: border-box;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
  color: white;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  & ~ & {
    margin-left: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/placeOrder/components/globalPriceComparison/index.vue